module.exports = __webpack_public_path__ + "img/chewei.44d85d8d.jpg";